export default __webpack_public_path__ + "static/meltyraise-dfcfd3d05f2e8415993d91694076f0c6.png";